import React, { useState } from 'react';
import { StyleSheet, Text, TextInput, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '../components/Button';
import { ContentView } from '../components/ContentView';
import { emailSelector, environmentSelector, setEmail, setEnvironmentConfig, } from '../redux/appSlice';
import { useForgotPasswordMutation } from '../services/abbiWayApi';
import { applyEnvironmentForLogin, resolveLoginEmailFromInput, } from '../utils/resolveLoginEmailFromInput';
import { reportServerError } from '../utils/reportServerError';
import { theme } from '../theme';
export const ForgotPasswordScreen = ({ route, }) => {
    const storedEmail = useSelector(emailSelector);
    const currentEnvironment = useSelector(environmentSelector);
    const hintFromSignIn = route.params?.emailHint;
    const [emailTyped, setEmailTyped] = useState(() => hintFromSignIn ?? storedEmail ?? '');
    const [message, setMessage] = useState(null);
    const dispatch = useDispatch();
    const [forgotPassword, { isLoading }] = useForgotPasswordMutation();
    const submit = async () => {
        const trimmed = emailTyped.trim();
        if (!trimmed) {
            return;
        }
        const { email: loginEmail, environment } = resolveLoginEmailFromInput(emailTyped, currentEnvironment);
        const env = applyEnvironmentForLogin(environment);
        dispatch(setEnvironmentConfig({
            environment: env.environment,
            backendBaseUrl: env.backendBaseUrl,
            frontendBaseUrl: env.frontendBaseUrl,
        }));
        dispatch(setEmail(emailTyped));
        setMessage(null);
        try {
            await forgotPassword({ email: loginEmail }).unwrap();
            setMessage('If that email is registered, we sent a link to reset your password.');
        }
        catch (err) {
            reportServerError(err);
        }
    };
    return (<ContentView>
      <View style={styles.container}>
        <Text style={styles.label}>Email</Text>
        <TextInput style={styles.input} placeholder="email address" value={emailTyped} onChangeText={setEmailTyped} autoCapitalize="none" keyboardType="email-address" autoComplete="email"/>
        {message ? (<Text style={styles.message}>{message}</Text>) : null}
        <View style={styles.button}>
          <Button title={isLoading ? 'Sending...' : 'Send reset link'} disabled={!emailTyped.trim().length || isLoading} onPress={submit}/>
        </View>
      </View>
    </ContentView>);
};
const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 24,
        paddingTop: 24,
    },
    label: {
        fontSize: 16,
        marginBottom: 8,
    },
    input: {
        fontSize: 16,
        paddingHorizontal: 10,
        marginBottom: 16,
        height: 44,
        borderWidth: 1,
        borderRadius: 8,
        backgroundColor: theme.colors.surfaceElevated,
    },
    message: {
        fontSize: 15,
        marginBottom: 16,
        color: theme.colors.textTitle,
    },
    button: {
        marginTop: 8,
    },
});
